/**
 * Date range filter preset types.
 *
 * These values must match the backend constants in app/api/utils/constants.py
 * Used for filtering by date ranges with predefined presets like 'overdue' or 'next_week'.
 */
export const DateRangeType = {
  NO_DATE: 'no_date',
  OVERDUE: 'overdue',
  NEXT_WEEK: 'next_week',
  NEXT_MONTH: 'next_month',
  CUSTOM: 'custom',
} as const

export type DateRangeType = typeof DateRangeType[keyof typeof DateRangeType]

/**
 * Human-readable labels for date range types.
 * Used in dropdown menus and chip displays.
 */
export const DateRangeTypeLabels: Record<DateRangeType, string> = {
  [DateRangeType.NO_DATE]: 'No Check-in Date',
  [DateRangeType.OVERDUE]: 'Overdue',
  [DateRangeType.NEXT_WEEK]: 'Next Week',
  [DateRangeType.NEXT_MONTH]: 'Next Month',
  [DateRangeType.CUSTOM]: 'Custom Range',
}

/**
 * Convert date range type constants to dropdown options.
 * Returns array of {value, label} objects for use in select components.
 */
export function getDateRangeOptions() {
  return Object.entries(DateRangeType).map(([_, value]) => ({
    value,
    label: DateRangeTypeLabels[value],
  }))
}
